import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button } from '@ipc/ipc-components';
import { tableCheckItemsSetSuccess, tableLoadData } from '../../../../../common/list-table/actions/ListTableActions';
import {
  getContactListByImpc, getIsContactListByImpcLoading, getAssociateRequestStatus, getCreateRequestStatus,
} from '../redux/selectors/MRDContactManagementSelectors';
import { MRDContactManagementStyles } from '../components/MRDContactManagement.styles';
import ListTable from '../../../../../common/list-table/components/ListTable';
import TableDefinitions from '../../../../../common/TableDefinitions';
import AddContactDialog from './AddContactDialog';
import MrdContactsCreateDialog from '../../../contact-management/create/component/MrdContactsCreateDialog';
import { MRDContactsTableColumns } from './MRDContactsTableColumns';
import { addNewContactRequestActionCreator } from '../../../contact-management/redux/actions/ContactsActions';

function MRDContactManagementContainer(props) {
  const {
    contactListByImpc,
    isContactListLoading,
    selectedImpc,
    tableLoad,
    closeWizard,
    addContact,
    associateContactRequestStatus,
    createContactRequestStatus,
  } = props;

  const [showAddContactDialog, setShowAddContactDialog] = useState(false);
  const [showCreateContactDialog, setShowCreateContactDialog] = useState(false);
  const [contactList, setContactList] = useState([]);
  const associateContactRequestStatusRef = useRef(associateContactRequestStatus);
  const createContactRequestStatusRef = useRef(createContactRequestStatus);

  useEffect(() => {
    if (!associateContactRequestStatus && associateContactRequestStatusRef.current) {
      tableLoad(TableDefinitions.MRD_CONTACTS_WIZARD.id, { impcCode: selectedImpc });
    }
    associateContactRequestStatusRef.current = associateContactRequestStatus;
  }, [associateContactRequestStatus]);

  useEffect(() => {
    if (!createContactRequestStatus && createContactRequestStatusRef.current) {
      tableLoad(TableDefinitions.MRD_CONTACTS_WIZARD.id, { impcCode: selectedImpc });
    }
    createContactRequestStatusRef.current = createContactRequestStatus;
  }, [createContactRequestStatus]);

  const columns = MRDContactsTableColumns(contactList);

  useEffect(() => {
    tableLoad(TableDefinitions.MRD_CONTACTS_WIZARD.id, { impcCode: selectedImpc });
  }, []);

  useEffect(() => {
    setContactList(contactListByImpc);
  }, [contactListByImpc]);

  const confirmAddNewContact = async (requestData) => {
    setShowCreateContactDialog(false);
    await addContact(requestData);
  };

  return (
    <MRDContactManagementStyles>
      <div className="add-mrd-container-buttons">
        <Button className="cancel primary-button-false" onClick={() => closeWizard()}>Cancel</Button>
        <Button
          className="primary-button-false right-alignment"
          onClick={closeWizard}
        >
          Finish
        </Button>
      </div>
      <div className="add-mrd-container-body">
        <div className="mrd-contacts">
          <div className="mrd-contact-button-container">
            <Button
              className="primary-button-false mrd-contact-button"
              onClick={() => setShowAddContactDialog(true)}
            >
              Add Contact
            </Button>
            <Button
              className="primary-button-false mrd-contact-button"
              onClick={() => setShowCreateContactDialog(true)}
            >
              Create Contact
            </Button>
          </div>
          <ListTable
            listId={TableDefinitions.MRD_CONTACTS_WIZARD.id}
            data={contactList}
            loading={isContactListLoading}
            columns={columns}
          />
        </div>
      </div>
      <AddContactDialog
        openDialog={showAddContactDialog}
        closeDialog={() => setShowAddContactDialog(false)}
        selectedImpc={selectedImpc}
      />
      {showCreateContactDialog && (
        <MrdContactsCreateDialog
          isOpen
          closeDialog={() => setShowCreateContactDialog(false)}
          handleCancel={() => setShowCreateContactDialog(false)}
          selectedImpc={selectedImpc}
          addNewContact={confirmAddNewContact}
          isWizard
        />
      )}

    </MRDContactManagementStyles>
  );
}
function mapStateToProps(state) {
  return {
    contactListByImpc: getContactListByImpc(state),
    isContactListLoading: getIsContactListByImpcLoading(state),
    associateContactRequestStatus: getAssociateRequestStatus(state),
    createContactRequestStatus: getCreateRequestStatus(state),
  };
}

MRDContactManagementContainer.propTypes = {
  closeWizard: PropTypes.func,
  selectedImpc: PropTypes.string,
  tableLoad: PropTypes.func,
  isContactListLoading: PropTypes.bool,
  contactListByImpc: PropTypes.arrayOf(PropTypes.object),
  addContact: PropTypes.func,
  associateContactRequestStatus: PropTypes.bool,
  createContactRequestStatus: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoad: tableLoadData,
  checkItems: tableCheckItemsSetSuccess,
  addContact: addNewContactRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MRDContactManagementContainer);
